import { render, staticRenderFns } from "./m_public_teacher_policy_interpretation.vue?vue&type=template&id=ff1df29a&scoped=true"
import script from "./m_public_teacher_policy_interpretation.vue?vue&type=script&lang=js"
export * from "./m_public_teacher_policy_interpretation.vue?vue&type=script&lang=js"
import style0 from "./m_public_teacher_policy_interpretation.vue?vue&type=style&index=0&id=ff1df29a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1df29a",
  null
  
)

export default component.exports